<script
    setup
    lang="ts"
>
import AppUploadedFile from "@/components/UI/AppUploadedFile.vue";

const props = withDefaults(defineProps<{
  items: any[];
  title?: string
}>(), {
  items: () => [],
  title: 'Прикреплённые файлы'
})
</script>

<template>
  <div class="custom-assessment__files">
    <h5 class="custom-assessment__sidebar__label">{{props.title}}</h5>
    <app-uploaded-file
        v-if="props.items?.length"
        v-for="(file, index) in items"
        :key="index"
        :file
    />
    <p
        v-else
        class="custom-assessment__description__text"
    >
      <i>Файлы отсутствуют</i>
    </p>
  </div>
</template>